import React, {PureComponent, ReactNode} from 'react';
import I18n from 'app/i18n';
import {getLinkPath} from 'app/utils/link_helper';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';

interface FastRegistrationConsentProps {
    rowClass: string;
    error?: string | null;
    cleanError: (field: string) => void;
}

export default class FastRegistrationConsent extends PureComponent<FastRegistrationConsentProps> {
    cleanError = (): void => {
        this.props.cleanError('terms_of_use');
    };

    linkHtml = (path: string, key: string): string => {
        const href = getLinkPath(path);

        return `<a target="_blank" rel="noopener noreferrer" href="${href}">${I18n.t(key)}</a>`;
    };

    termsLabel = (): string => I18n.t('registration_terms_agree', {
        betting_rules_link: this.linkHtml('/betting_rules', 'betting_rules'),
        policy_link: this.linkHtml('/privacy_policy', 'privacy_policy'),
        terms_link: this.linkHtml('/terms_and_conditions', 'terms_and_conditions')
    });

    renderCheckbox(name: string, label: string, onChange?: () => void): ReactNode {
        return <div className="field">
            <label className="field__check">
                <input
                    className="field__check-hidden"
                    name={name}
                    type="checkbox"
                    value="1"
                    onChange={onChange}
                />
                <div className="field__check-box">
                    <SpriteIcon name="#svg-check" size={{height: 11, width: 15}}/>
                </div>
                <span className="label" dangerouslySetInnerHTML={{__html: label}}/>
            </label>
        </div>;
    }

    render(): ReactNode {
        const {rowClass, error} = this.props;

        return <div className="registration-terms">
            <div className={rowClass}>
                {this.renderCheckbox('terms_of_use', this.termsLabel(), this.cleanError)}
                {error && <div className="field__error-hint">{error}</div>}
            </div>
            {this.renderCheckbox('marketing_consent', I18n.t('registration_marketing_consent'))}
        </div>;
    }
}
